/* unplugin-vue-components disabled */import script from "./RewardsVIew.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardsVIew.vue?vue&type=script&setup=true&lang=js"

import "./RewardsVIew.vue?vue&type=style&index=0&id=ab1a4b14&lang=scss"

const __exports__ = script;

export default __exports__